/*
 * Sticky add to cart — the bar stands by default, and stands down only while
 * something it has been told to keep clear of is on screen. Out of the box that is
 * the buy buttons on the page and the footer: there is nothing for the bar to offer
 * while a real button is in reach, and a bar pinned over the footer covers the links
 * a reader has scrolled all the way down to get to.
 *
 * What to keep clear of comes from the section's `data-hide-selectors`
 * attribute, so it is a theme editor setting rather than a list hard-coded here.
 * An IntersectionObserver tracks how many of those elements are on screen; the
 * bar is hidden while that count is above zero and shown again the moment it
 * falls back to none.
 */
(function () {
  const READY = 'stickyAtcReady';
  const VISIBLE_CLASS = 'sticky-atc--visible';

  function show(bar) {
    bar.classList.add(VISIBLE_CLASS);
  }

  function hide(bar) {
    bar.classList.remove(VISIBLE_CLASS);
  }

  function collectTargets(bar) {
    const raw = bar.getAttribute('data-hide-selectors') || '';
    const targets = [];

    raw
      .split(',')
      .map(function (selector) {
        return selector.trim();
      })
      .filter(Boolean)
      .forEach(function (selector) {
        let found;
        try {
          found = document.querySelectorAll(selector);
        } catch (error) {
          // A selector typed into the theme editor can be invalid. Skip it rather
          // than letting one typo stop the rest of the list being watched.
          return;
        }

        Array.prototype.forEach.call(found, function (element) {
          // A selector reaching inside the bar itself would keep it permanently
          // hidden: the bar is on screen whenever the bar is on screen.
          if (bar.contains(element)) return;
          if (targets.indexOf(element) === -1) targets.push(element);
        });
      });

    return targets;
  }

  function setup(bar) {
    if (bar.dataset[READY] === 'true') return;
    bar.dataset[READY] = 'true';

    const targets = collectTargets(bar);

    // Nothing to watch — either no selectors were given, none of them matched, or
    // the browser cannot observe them. Standing is the default, so the bar stays.
    if (!targets.length || typeof IntersectionObserver === 'undefined') {
      show(bar);
      return;
    }

    const visible = new Set();

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            visible.add(entry.target);
          } else {
            visible.delete(entry.target);
          }
        });

        if (visible.size > 0) {
          hide(bar);
        } else {
          show(bar);
        }
      },
      { threshold: 0 }
    );

    targets.forEach(function (target) {
      observer.observe(target);
    });
  }

  function initAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-sticky-atc]').forEach(setup);
  }

  function start() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /*
   * The editor re-renders one section at a time. The bar watches elements that live
   * in *other* sections, so a re-render anywhere can leave it observing elements
   * that have been replaced — the flag is cleared and every bar is wired up again
   * against the current DOM.
   */
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-sticky-atc]').forEach(function (bar) {
      delete bar.dataset[READY];
    });
    start();
  });
})();
